webpackJsonp([5],{

/***/ 5000:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_work__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_theme__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Adobe__ = __webpack_require__(5055);
var mapStateToProps=function mapStateToProps(state){return{next:state.work.sketches,prev:state.work.lightblades,theme:state.theme};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{load:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_2__actions_work__["a" /* default */].fetch,dispatch),loadTheme:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_3__actions_theme__["a" /* default */].fetch,dispatch)};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__pages_Adobe__["a" /* default */]));

/***/ }),

/***/ 5014:
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(5029);

/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;

  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = baseRandom(index, lastIndex),
        value = array[rand];

    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

module.exports = shuffleSelf;


/***/ }),

/***/ 5015:
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(5034),
    keys = __webpack_require__(110);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),

/***/ 5016:
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(2059),
    isArrayLike = __webpack_require__(108),
    isIndex = __webpack_require__(2060),
    isObject = __webpack_require__(106);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 5017:
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(5026);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 5018:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),

/***/ 5019:
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 5026:
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(5027);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 5027:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(106),
    isSymbol = __webpack_require__(109);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 5029:
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),

/***/ 5030:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(2061);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidHappy = function IoAndroidHappy(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 3.8c8.9 0 16.2 7.3 16.2 16.2s-7.3 16.3-16.2 16.3-16.3-7.4-16.3-16.3 7.3-16.2 16.3-16.2z m0 29.2c7.1 0 12.9-5.8 12.9-13s-5.8-13-12.9-13-13 5.8-13 13 5.8 13 13 13z m5.7-14.6c-1.5 0-2.5-1.1-2.5-2.5s1-2.4 2.5-2.4 2.4 1 2.4 2.4-1 2.5-2.4 2.5z m-11.5 0c-1.4 0-2.4-1.1-2.4-2.5s1-2.4 2.4-2.4 2.5 1 2.5 2.4-1 2.5-2.5 2.5z m5.8 10.5c-3.9 0-7-2.3-8.3-5.6h16.5c-1.3 3.3-4.4 5.6-8.2 5.6z' })
        )
    );
};

exports.default = IoAndroidHappy;
module.exports = exports['default'];

/***/ }),

/***/ 5031:
/***/ (function(module, exports, __webpack_require__) {

var arraySampleSize = __webpack_require__(5032),
    baseSampleSize = __webpack_require__(5033),
    isArray = __webpack_require__(24),
    isIterateeCall = __webpack_require__(5016),
    toInteger = __webpack_require__(5017);

/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */
function sampleSize(collection, n, guard) {
  if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = toInteger(n);
  }
  var func = isArray(collection) ? arraySampleSize : baseSampleSize;
  return func(collection, n);
}

module.exports = sampleSize;


/***/ }),

/***/ 5032:
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(5018),
    copyArray = __webpack_require__(5019),
    shuffleSelf = __webpack_require__(5014);

/**
 * A specialized version of `_.sampleSize` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function arraySampleSize(array, n) {
  return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
}

module.exports = arraySampleSize;


/***/ }),

/***/ 5033:
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(5018),
    shuffleSelf = __webpack_require__(5014),
    values = __webpack_require__(5015);

/**
 * The base implementation of `_.sampleSize` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function baseSampleSize(collection, n) {
  var array = values(collection);
  return shuffleSelf(array, baseClamp(n, 0, array.length));
}

module.exports = baseSampleSize;


/***/ }),

/***/ 5034:
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(2062);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ 5035:
/***/ (function(module, exports, __webpack_require__) {

var arrayShuffle = __webpack_require__(5036),
    baseShuffle = __webpack_require__(5037),
    isArray = __webpack_require__(24);

/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  var func = isArray(collection) ? arrayShuffle : baseShuffle;
  return func(collection);
}

module.exports = shuffle;


/***/ }),

/***/ 5036:
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(5019),
    shuffleSelf = __webpack_require__(5014);

/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function arrayShuffle(array) {
  return shuffleSelf(copyArray(array));
}

module.exports = arrayShuffle;


/***/ }),

/***/ 5037:
/***/ (function(module, exports, __webpack_require__) {

var shuffleSelf = __webpack_require__(5014),
    values = __webpack_require__(5015);

/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function baseShuffle(collection) {
  return shuffleSelf(values(collection));
}

module.exports = baseShuffle;


/***/ }),

/***/ 5038:
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(5039),
    isIterateeCall = __webpack_require__(5016),
    toInteger = __webpack_require__(5017);

/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
    start = 0;
    end = length;
  }
  else {
    start = start == null ? 0 : toInteger(start);
    end = end === undefined ? length : toInteger(end);
  }
  return baseSlice(array, start, end);
}

module.exports = slice;


/***/ }),

/***/ 5039:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 5041:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMailtoLink = exports.toSearchString = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var toSearchString = exports.toSearchString = function toSearchString() {
  var searchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object.keys(searchParams).map(function (key) {
    return key + '=' + encodeURIComponent(searchParams[key]);
  }).join('&');
};

var createMailtoLink = exports.createMailtoLink = function createMailtoLink(email, headers) {
  var link = 'mailto:' + email;
  if (headers) {
    link += '?' + toSearchString(headers);
  }
  return link;
};

var Mailto = function (_Component) {
  _inherits(Mailto, _Component);

  function Mailto() {
    _classCallCheck(this, Mailto);

    return _possibleConstructorReturn(this, (Mailto.__proto__ || Object.getPrototypeOf(Mailto)).apply(this, arguments));
  }

  _createClass(Mailto, [{
    key: 'render',
    value: function render() {
      return this.props.obfuscate ? this.renderObfuscatedLink() : this.renderLink();
    }
  }, {
    key: 'renderLink',
    value: function renderLink() {
      var _props = this.props,
          email = _props.email,
          obfuscate = _props.obfuscate,
          headers = _props.headers,
          children = _props.children,
          others = _objectWithoutProperties(_props, ['email', 'obfuscate', 'headers', 'children']);

      return _react2.default.createElement(
        'a',
        _extends({ href: createMailtoLink(email, headers) }, others),
        children
      );
    }
  }, {
    key: 'renderObfuscatedLink',
    value: function renderObfuscatedLink() {
      var _props2 = this.props,
          email = _props2.email,
          obfuscate = _props2.obfuscate,
          headers = _props2.headers,
          children = _props2.children,
          others = _objectWithoutProperties(_props2, ['email', 'obfuscate', 'headers', 'children']);

      return _react2.default.createElement(
        'a',
        _extends({ onClick: this.handleClick.bind(this), href: 'mailto:obfuscated' }, others),
        children
      );
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      event.preventDefault();
      var _props3 = this.props,
          email = _props3.email,
          headers = _props3.headers;

      window.location.href = createMailtoLink(email, headers);
    }
  }]);

  return Mailto;
}(_react.Component);

Mailto.propTypes = {
  children: _propTypes2.default.node.isRequired,
  email: _propTypes2.default.string.isRequired,
  headers: _propTypes2.default.object,
  obfuscate: _propTypes2.default.bool
};

Mailto.defaultProps = {
  obfuscate: false
};

exports.default = Mailto;


/***/ }),

/***/ 5055:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(2058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scrollmonitor_react__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scrollmonitor_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_scrollmonitor_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_icons_lib_io_android_happy__ = __webpack_require__(5030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_icons_lib_io_android_happy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_icons_lib_io_android_happy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_map__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_sampleSize__ = __webpack_require__(5031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_sampleSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_sampleSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_shuffle__ = __webpack_require__(5035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_shuffle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_slice__ = __webpack_require__(5038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_mailto__ = __webpack_require__(5041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_mailto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_mailto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Animated__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_BigList__ = __webpack_require__(2063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Image__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(52);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var getImage=function getImage(folder,filename,r){return[{srcSet:__webpack_require__(44)("./"+folder+'/'+filename+'-thumb-'+r+'.jpg'),media:'(max-width: 100px)'},{srcSet:__webpack_require__(44)("./"+folder+'/'+filename+'-sm-'+r+'.jpg'),media:'(max-width: 720px)'},{srcSet:__webpack_require__(44)("./"+folder+'/'+filename+'-'+r+'.jpg')}];};var getImageSequence=function getImageSequence(folder,filename,start,end){var imgs=[];for(var i=start;i<=end;i++){// note: we add a key prop here to allow react to uniquely identify each
// element in this array. see: https://reactjs.org/docs/lists-and-keys.html
imgs.push(getImage(folder,filename,i));}return imgs;};var row1=function row1(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_10__styles__["d" /* fullWidth */],{key:'image-'+index}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Image__["a" /* default */],{sources:image}));};var row2=function row2(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_10__styles__["f" /* halfWidth */],{key:'image-'+index}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Image__["a" /* default */],{sources:image}));};var row3=function row3(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_10__styles__["v" /* thirdWidth */],{key:'image-'+index}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Image__["a" /* default */],{sources:image}));};var unreleasedImages=getImageSequence('unreleased','unreleased-generative-art-by-lucastswick',1,28);var Adobe=function(_Component){_inherits(Adobe,_Component);function Adobe(props){_classCallCheck(this,Adobe);var _this=_possibleConstructorReturn(this,(Adobe.__proto__||Object.getPrototypeOf(Adobe)).call(this,props));_this.getBlomHeader=function(index){return[{srcSet:__webpack_require__(111)("./blom-a-generative-art-series-by-lucastswick-thumb-"+index+'.jpg'),media:'(max-width: 100px)'},{srcSet:__webpack_require__(2064)("./blom-a-generative-art-series-by-lucastswick-sm-"+index+'.jpg'),media:'(max-width: 720px)'},{srcSet:__webpack_require__(2065)("./blom-a-generative-art-series-by-lucastswick-"+index+'.jpg')}];};_this.state={set1:[]};return _this;}_createClass(Adobe,[{key:'componentWillMount',value:function componentWillMount(){this.props.loadTheme();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var blomHeader=this.getBlomHeader(1);// const galleryHeader = getImage('laika', 'gallery', 1);
var headerImage=getImage('community-gardens','community-gardens-header',1);var set1=__WEBPACK_IMPORTED_MODULE_7_lodash_slice___default()(unreleasedImages,0,4);set1=__WEBPACK_IMPORTED_MODULE_5_lodash_sampleSize___default()(__WEBPACK_IMPORTED_MODULE_6_lodash_shuffle___default()(set1),3);set1.push(unreleasedImages[5]);var set2=__WEBPACK_IMPORTED_MODULE_7_lodash_slice___default()(unreleasedImages,6,10);set2=__WEBPACK_IMPORTED_MODULE_5_lodash_sampleSize___default()(__WEBPACK_IMPORTED_MODULE_6_lodash_shuffle___default()(set2),2);var set3=__WEBPACK_IMPORTED_MODULE_7_lodash_slice___default()(unreleasedImages,11,15);set3=__WEBPACK_IMPORTED_MODULE_5_lodash_sampleSize___default()(__WEBPACK_IMPORTED_MODULE_6_lodash_shuffle___default()(set3),3);var set4=__WEBPACK_IMPORTED_MODULE_7_lodash_slice___default()(unreleasedImages,16,21);set4=__WEBPACK_IMPORTED_MODULE_5_lodash_sampleSize___default()(__WEBPACK_IMPORTED_MODULE_6_lodash_shuffle___default()(set4),2);this.setState({set1:set1,set2:set2,set3:set3,set4:set4,headerImage:headerImage,items:{nfts:{title:'Generative art is creativity, automated',uid:'nfts',slug:'nfts',// link: 'https://foundation.app/collection/solastalgia?sort=newest',
excerpt:'The very first minted on-chain artwork in my generative series Blóm.',// cta: 'See it on Foundation',
// colorTheme: { base: '#121212', hilite: '#df0000' },
headerImage:blomHeader,images:[blomHeader]}// frahm: {
//   title: 'However…',
//   uid: 'however',
//   slug: 'however',
//   link: 'https://gallery.frahm.art/',
//   excerpt:
//     'It turns out being an artist can be tumultuous! In an effort to create more financial stability, I co-founded an art-adjacent startup that makes generative frames for digital art, and we received pre-seed funding. I have been enjoying the engineering challenges of building a Web3 product from scratch that leverages blender, react-three-fiber, 3D animation, and AR/VR.',
//   cta: 'Explore our Gallery',
//   // colorTheme: { base: '#121212', hilite: '#df0000' },
//   headerImage: galleryHeader,
//   images: [galleryHeader],
// },
}});}},{key:'render',value:function render(){var _state=this.state,items=_state.items,headerImage=_state.headerImage,set1=_state.set1,set2=_state.set2,set3=_state.set3,set4=_state.set4;var theme=this.props.theme;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Image__["a" /* default */],{ratio:'16x9',sources:headerImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["u" /* textContainer */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet___default.a,{title:'Adobe + Lucas',description:'\uD83D\uDC95'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h1'},'Hello!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'I\'m Lucas, Senior Software Engineer and Creative Coder.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'I\'ve been using technology in my creative pursuits since I was a teenager, drawing album covers in Photoshop for my band and writing tools to generate visuals for our live shows. I found a home writing html/js/css for the browser, knowing I could make tools and sites, games and art that anyone can access. I\'ve been building things on the web ever since.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'Recently, I rode the NFT wave and created unique vanilla javascript',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["b" /* Link */],{to:'/work/blom-a-generative-art-series'},'generative art'),'. I then co-founded an art-adjacent startup that makes',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://fdk.frahm.art/editor',target:'_blank',rel:'nofollow noopener noreferrer'},'generative frames for digital art'),'. I have been enjoying the engineering challenges of building a web application from scratch that leverages React, Blender, React Three Fiber, 3D animation, shaders, and a custom component library. It exports dynamic .usdz files for viewing in AR/VR. Neat.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_BigList__["a" /* default */],{items:items,theme:theme,showExcerptOnSm:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["u" /* textContainer */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'Previously'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'I was a ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Technical Director at Nike'),', where I managed the front-end team of a startup in an Incubator program. We shipped a subscription service for kids shoes, and built multiple internal tools for the CS and fulfillment teams, including a data-driven generative art installation that displayed sales data in a mythic forest. We wrote our own component library from scratch. I also played the role of Senior Engineer, and enjoy the challenge of balancing the needs of the business with the needs of the team. I\'m proud of the work we accomplished.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'Before that, I worked with different design agencies, and delivered',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["b" /* Link */],{to:'/work/generative-art-installation-in-union-square'},'installations'),' ','that ran on 20 foot tall digital displays in Union Square, NY while shipping CMS driven websites like',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://rideicon.com/gear',target:'_blank',rel:'nofollow noopener noreferrer'},'Icon Motosports'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'While my day job was full of exciting challenges, I kept pushing my creative skills with different projects including',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["b" /* Link */],{to:'/work/community-gardens-a-data-driven-generative-art-installation-about-housing-insecurity-at-ncsu'},'data-driven art installations'),', C++ generative art projects, and',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://vimeo.com/user733911',target:'_blank',rel:'nofollow noopener noreferrer'},'song-writing and music-video making'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'Why am I a good fit for Adobe?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'I LOVE building tools, and I cannot express what a joy it would be to create tools that help people be more creative. I firmly believe the world is a better place with more art in it, and if I can help people be more expressive, welp, that\'s a win in my book.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'I\'ll show up with an incredible amount of enthusiasm and positivity to apply the skills I\'ve learned over the years to help Adobe continue to be the leader in creative software. I\'m a team player, and I\'m excited to work with a group of like-minded folx who are passionate about the intersection of creativity and technology.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'Why is Adobe a good fit for me?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'To be honest, I\'ve been a fan of Adobe since I was a kid. I remember the first time I used Photoshop. I saved up for a wacom tablet and drew for hours and hours. Seeing the products evolve over the years and expand into new areas (why hello there Lightroom) has been inspiring. I want to be a part of that. I want to help shape the future of creative software and push the boundaries of what is possible. I want to be a part of Adobe.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{width:'100%',height:'auto',autoPlay:true,loop:true,muted:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:'/vid/header-full.mp4',type:'video/mp4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Image__["a" /* default */],{ratio:'16x9',sources:headerImage,theme:theme})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["u" /* textContainer */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'Employment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2024'),' My team and I are building an AI-powered nostalgia-induced VRM (a standard for 3D characters that can be used across games and experiences) collection, based on a sci-fi universe created by an artist. We are delivering thousands of generated 3D models, where each one has a unique personality and experience that users can interact with. Currently in stealth mode.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2022'),' Co-founded',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://fdk.frahm.art/editor',target:'_blank',rel:'nofollow noopener noreferrer'},'Frahm'),', generative frames for your digital art',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2021'),' Sold some NFTs (remember those?) over',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://opensea.io/collection/blom-by-lucastswick',target:'_blank',rel:'nofollow noopener noreferrer'},'multiple'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://opensea.io/collection/lucastswick-form-decay',target:'_blank',rel:'nofollow noopener noreferrer'},'generative art'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://foundation.app/collection/solastalgia',target:'_blank',rel:'nofollow noopener noreferrer'},'collections'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2018-2021'),' Nike, Technical Director',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2018'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/work/community-gardens-a-data-driven-generative-art-installation-about-housing-insecurity-at-ncsu',target:'_blank',rel:'nofollow noopener noreferrer'},'Community Gardens'),', a data-driven generative art installation at NCSU. Was awarded an artist residency',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2015-2018'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://weareparliament.com/',target:'_blank',rel:'nofollow noopener noreferrer'},'Parliament'),', Technical Director. Worked with brands like Capital One, Icon Motorsports, Prometheus, and more, while building internal tools for the agency.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'2017'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/work/lightblades-installation-at-the-geode-in-portland',target:'_blank',rel:'nofollow noopener noreferrer'},'Lightblades'),', a 3-story tall generative art public art installation at the Geode, Portland OR',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Previous'),' Various agencies; Software Engineer, Flash developer, delivering work for Nike, LucasArts, Lego, and more.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'Competencies'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'ul'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Strong engineering skills and over 10 years creating front-end experiences'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Delivers high-performance, reliable, well-documented, and maintainable code.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'High tolerance for ambiguity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Super-lover of teamwork; also very capable of participating in all aspects of development lifecycle, from concepting through development to maintenance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'A long history of successfully saying Let\'s try it! to new challenges'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Effective communicator'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Patient debugger'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Creative problem solver'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Nimble minded when moving along gradient from high level strategy to local details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Measured optimist'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Bringer of good vibes to any opportunity')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'Skills'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'During my career, I\'ve often picked up new skills for specific projects. I taught myself enough C++ to generate thousands of high-resolution artworks that a browser couldn\'t handle, extended CraftCMS with custom plugins to deliver a job-application management system to handle the ridiculous amounts of emails that a job posting would create, maintained projects at Nike that were built by vendors, and am currently learning Python so I can script inside Blender and make my life easier. I\'m eager to learn and a fast study.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'ul'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Advanced proficiency with HTML, CSS, and JavaScript'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'10+ years collaborating with clients directly while at creative agencies'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'8+ years of being a Technical Director, responsible for defining project methodologies (agile, scrum) and dev ops'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Multiple large-scale installations created with THREE.js or processing'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Shipped my first React app in 2015 and never looked back. React was still in beta and the webapp (which uses threejs as well) is actually',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://hsstudio.haydenshapes.com/hsstudio/?activeLocationUid=us&activeBoardUid=hypto-krypto',target:'_blank',rel:'nofollow noopener noreferrer'},'still live')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'3 years in the Web3 space, mostly shipping generative Web3D experiences'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Very eager to learn new programs')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'Values'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'ul'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Kindness first. Assume the best in people by default.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Inclusive, non-judgemental environments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Building community and relationships'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'A clean code base'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Nimble, forward-thinking peers')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'Superpowers'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'ul'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Woodworker'),' currently building bespoke furniture which Milly Cypress, my CNC machine that carves generative patterns into wood.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Musician'),' creating an audio-reactive experience'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Canadian with ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'US Green Card')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Vegan, sober, but ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'still fun'),' (I think)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'Some samples of my generative art'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'These are generated in-browser with Javascript and THREE.js.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["x" /* wrapper */],__WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(set1,function(image,index){if(index<3){return row3(image,index);}else if(index%3===0){return row1(image,index);}else{return row3(image,index);}}),__WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(set2,function(image,index){if(index%5===0){var image2=set2[index+1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:'group-'+index},row2(image,index),row2(image2,index+1));}else if(index%5===1){return null;}else{return row3(image,index);}}),__WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(set3,function(image,index){return row3(image,index);}),__WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(set4,function(image,index){if(index===0){var image2=set4[index+1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:'group-'+index},row2(image,index),row2(image2,index+1));}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["u" /* textContainer */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'What\'s next?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'I\'d love to learn more about the Founding Engineer, Emerging Product Incubation role at Adobe. Honestly, you are doing cool work, and at the very least we should grab a coffee.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'Email me:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_mailto___default.a,Object.assign({email:'lucas@generativeartist.com',obfuscate:true},__WEBPACK_IMPORTED_MODULE_10__styles__["t" /* shadowless */],{target:'_blank'}),'lucas@generativeartist.com')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["b" /* center */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'div'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_icons_lib_io_android_happy___default.a,{color:'#F772D7',size:90})))));}}]);return Adobe;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_scrollmonitor_react__["Watch"])(Adobe));

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.8f7381a6.chunk.js